import { $ } from "../utils";

// Tab component
const VillasSlider = () => {
    // Button active class
    const buttonActiveClass = 'swiper-slide-thumb-active';
    // Getting all wrappers
    const wrappers = document.querySelectorAll('.villasTapSliderWrapper');
    // Each wrapper
    $(wrappers, (wrapper) => {
        // If wrapper not exist
        if (!wrappers || !wrappers.length) return;
        // Getting all tab buttons wrappers
        const buttons = wrapper.querySelectorAll('.villasTabSwiper .swiper-slide');
        // Each button
        $(buttons, (button) => {
            // Adding click event listener
            button.addEventListener('click', (e) => {
                // Prevent default event
                e.preventDefault();
                // Remove active state form all buttons
                $(buttons).removeClass(buttonActiveClass);
                // Adding active to current button
                button.classList.add(buttonActiveClass);
                // Getting corasponding tab id
                const id = button.dataset.tabId;
                // Getting all tabs
                const tabs = wrapper.querySelectorAll('.villasSwiper');
                // Remove class
                tabs.forEach((x) => {
                    x.classList.remove('active');
                });
                // Activate clicked item
                $(`#${id}`).addClass('active');
            });
        });
    });

    // Init Villas carousel
    new Swiper('.villasSwiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: true,
        speed: 1500,
        pagination: {
            el: ".villasSwiper-pagination",
            clickable: true,
        },
    });
    // Init Villas carousel
    new Swiper('.villasTabSwiper', {
        slidesPerView: 1.5,
        spaceBetween: 0,
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 6,
            },
        },
    });
};

// Export component
export default VillasSlider;